import React from 'react';
import { IconArrowUpRight, IconArrowDownRight, IconMinus } from '@tabler/icons-react';
import styles from './KpiCard.module.scss';
import type { KpiDatum } from '../reportMockData';

interface KpiCardProps {
  label: string;
  hint: string;
  datum: KpiDatum;
}

const KpiCard: React.FC<KpiCardProps> = ({ label, hint, datum }) => {
  const { value, delta, direction, higherIsBetter } = datum;

  const isGood =
    direction === 'flat'
      ? null
      : (direction === 'up') === higherIsBetter;

  const DeltaIcon =
    direction === 'up' ? IconArrowUpRight : direction === 'down' ? IconArrowDownRight : IconMinus;

  const deltaClass =
    isGood === null ? styles.deltaFlat : isGood ? styles.deltaGood : styles.deltaBad;

  return (
    <div className={styles.tile}>
      <span className={styles.label}>{label}</span>
      <span className={styles.value}>{value}</span>
      <div className={styles.footer}>
        <span className={`${styles.delta} ${deltaClass}`}>
          <DeltaIcon size={14} stroke={2.2} />
          {delta}
        </span>
        <span className={styles.hint}>{hint}</span>
      </div>
    </div>
  );
};

export default KpiCard;
